import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateSelection } from "../../../redux/actions/facilityActions";
import { formatFacilityCode } from "../../shared/functions/Functions";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";

const style = {
  inactive: {
    color: "#f5222d",
    backgroundColor: "#fff1f0",
    borderColor: "#ffa39e",
    border: "1px solid",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "2px 8px",
    float: "right",
  },
  active: {
    color: "#429e15",
    backgroundColor: "#f6ffed",
    borderColor: "#429e15",
    border: "1px solid",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "2px 8px",
    float: "right",
  },
  noMap: {
    color: "#808080",
    backgroundColor: "#f2f2f2",
    borderColor: "#cccccc",
    border: "1px solid",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "2px 8px",
    float: "right",
    marginRight: "10px",
  },
  faciltyType: {
    color: "white",
    backgroundColor: "#777777",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "2px 8px",
    float: "right",
    marginRight: "8px",
  },
};

export default function SearchItem(props) {
  const dispatch = useDispatch();
  const search = useSelector(state => state.search);
  const currentSelection = useSelector(state => state.currentSelection);
  const showInfoWindow = (
    epa_id,
    facName,
    facStreet1,
    facCity,
    facCounty,
    facZip,
    facLat,
    facLng,
    event
  ) => {
    //update store with selected card info only if selected facility has lat/long within CA
    if (
      (facLat === 0 && facLng === 0) ||
      facLat <= 10 ||
      facLat >= 50 ||
      facLng <= -180 ||
      facLng >= -45
    ) {
    } else {
      let showInfoWindow = true;
      dispatch(updateSelection(
        epa_id,
        facName,
        facStreet1,
        facCity,
        facCounty,
        facZip,
        facLat,
        facLng,
        showInfoWindow,
        "searchItem"
      ));
    }
  }

  const hideInfoWindow = () => {
    let epa_id = null;
    let facName = null;
    let facStreet1 = null;
    let facCity = null;
    let facCounty = null;
    let facZip = null;
    let facLat = null;
    let facLng = null;
    let showInfoWindow = false;
    let from = false;
    dispatch(updateSelection(
      epa_id,
      facName,
      facStreet1,
      facCity,
      facCounty,
      facZip,
      facLat,
      facLng,
      showInfoWindow,
      from
    ));
  }

  const noMapIndicator = (facLat, facLng, style) => {
    if (
      (facLat === 0 && facLng === 0) ||
      facLat <= 10 ||
      facLat >= 50 ||
      facLng <= -180 ||
      facLng >= -45
    ) {
      return (
        <OverlayTrigger
          key={"nomap"}
          placement={"top"}
          overlay={
            <Tooltip id={"tooltip-nomap"}>
              This Handler will not show up on the map due to insufficient
              address information.
            </Tooltip>
          }
        >
          <Badge
            className="float-right mt-1 m-r-sm"
            style={{ backgroundColor: "#e4e6e7", fontWeight: 500 }}
          >
            No Map
          </Badge>
        </OverlayTrigger>
      );
    }
    return;
  }

  useEffect(() => {
    if (
      currentSelection &&
      currentSelection.epa_id === props.result.EPA_ID &&
      currentSelection.from === "resultsMap"
    ) {
      let selectedItem = document.getElementsByClassName("selectedItem");
      selectedItem[0] && selectedItem[0].scrollIntoView({
        block: "center",
        behavior: search.searchResults.length > 5 ? "smooth" : "smooth",
      });
    }
  })

  function createTypeTags(codes) {
    var codes;
    if (Array.isArray(codes)) {
      codes = codes.map((code, i) => {
        if (code)
          return (
            <Badge
              key={i}
              className="m-r-sm mb-1 mb-xl-0"
              style={{
                backgroundColor: "#dae8f1",
                fontWeight: 500,
                fontSize: "0.75rem",
              }}
            >
              {code}
            </Badge>
          );
      });
    } else {
      if (codes.length > 0)
        codes = (
          <Badge
            className="m-r-sm mb-1 mb-xl-0"
            style={{
              backgroundColor: "#dae8f1",
              fontWeight: 500,
              fontSize: "0.75rem",
            }}
          >
            {codes}
          </Badge>
        );
    }
    return codes;
  }

  return (
    <div key={props.result.EPA_ID}>
      <div className="card-item" style={{ fontSize: "1rem" }}>
        <div
          className={`card-item-container${currentSelection && currentSelection.epa_id === props.result.EPA_ID ? " selectedItem" : ""}`}
          onMouseEnter={() => showInfoWindow(
            props.result.EPA_ID,
            props.result.Facility_Name,
            props.result.Street,
            props.result.City,
            props.result.County,
            props.result.Zip_Code,
            props.result.Fac_Latitude,
            props.result.Fac_Longitude
          )}
          onMouseLeave={() => hideInfoWindow()}
          style={{ backgroundColor: currentSelection && currentSelection.epa_id === props.result.EPA_ID ? "#aed0ea" : "inherit" }}
        >
          {ActiveInactiveOrTribalBadge(props)}
          <div className="no-map-marker">
            {noMapIndicator(
              props.result.Fac_Latitude,
              props.result.Fac_Longitude,
              style
            )}
          </div>
          <div style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
            {props.result.EPA_ID.toUpperCase()}
          </div>
          <div className="card-item-title">
            <Link to={"/facility/" + props.result.EPA_ID}>
              {props.result.Facility_Name.toUpperCase()}
            </Link>
          </div>
          <div>{props.result.Street}</div>
          <div>
            {props.result.City}, {props.result.State}{" "}
            {props.result.Zip_Code}
          </div>
          <div className="row" style={{ margin: 0, position: "relative" }}>
            <div className="m-t-sm" style={{ width: "75%" }}>
              {createTypeTags(
                formatFacilityCode(props.result.Facility_Type_Codes)
              )}
              <Badge
                className="m-r-sm"
                style={{
                  backgroundColor: "#e4e6e7",
                  fontWeight: 500,
                  fontSize: "0.75rem",
                }}
              >
                {props.result.Category}
              </Badge>
              <Badge
                className="m-r-sm"
                style={{
                  backgroundColor: "#e4e6e7",
                  fontWeight: 500,
                  fontSize: "0.75rem",
                }}
              >
                {props.result.Type}
              </Badge>
            </div>
            <div
              className="btn-detail-div"
              style={{
                width: "25%",
                position: "absolute",
                bottom: 0,
                right: 0,
                textAlign: "right",
              }}
            >
              <Link to={"/facility/" + props.result.EPA_ID}>
                <button className="btn-view-details">View Profile</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function ActiveInactiveOrTribalBadge(props) {
  if (props.result.Tribal) {
    return (<Badge
      className="mt-1 m-r-sm float-right"
      style={{ backgroundColor: "orange" }}
    >
      Tribal
    </Badge>);
  }

  return !props.result.Active ? (
    <Badge
      className="mt-1 m-r-sm float-right"
      style={{ backgroundColor: "#f0a8af" }}
    >
      Inactive
    </Badge>
  ) : (
      <Badge
        className="mt-1 m-r-sm float-right"
        style={{ backgroundColor: "#98e6ab" }}
      >
        Active
      </Badge>
    );
}